import { Component, AfterViewInit, Input, Output, EventEmitter, OnChanges, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { LocaStockService } from '../../../service/loca-stock/loca-stock.service';
import { TypeOperationService } from '../../../service/type-operation/type-operation.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';
import { config } from '../../../util/config';

@Component({
  selector: 'wa6012',
  templateUrl: 'wa6012.component.html',
  styleUrls: ['wa6012.component.scss']
})
export class Wa6012Component implements AfterViewInit, OnChanges {
  public componentTitle = 'WA6012:在庫修正';

  public typeoperations: any;

  public originalDt: FormControl;
  public bookDt: FormControl;
  private locastockpId: number;
  public locaId: number;
  public locaCd: string;
  public locaTx: number;
  public typestockTx: string;
  public typecoldTx: string;
  public itemId: number;
  public itemCd: number;
  public itemTx: number;
  public lotTx: string;
  public needUseLimit = false;
  public uselimitDt: string;
  public stockDt: string;
  public stockNr: number;
  public pstockNr: number;
  public cstockNr: number;
  public updstockNr: FormControl;
  public typeoperationCd: FormControl;
  public stockinoutmemoTx: FormControl;
  public typeoperationCheck: FormControl;
  private ownerTx: string;

  readonly STRINGS_ACTIVE = 'active';
  readonly STRINGS_ERROR = 'error';

  public originalDtCls = '';
  public bookDtCls = '';
  public caseaNrCls = '';
  public inneraNrCls = '';
  public baraNrCls = '';
  public stockinoutmemoTxCls = '';
  public typeoperationCheckCls = '';

  public validation = validation;

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  public checkbox = 0;
  private errorInfo = '';

  @ViewChild('scrollContent')
  scrollContent: ElementRef;
  @Input()
  private isShow = false;
  @Output() closeButtonClick = new EventEmitter<boolean>();
  private isDelayHide = true;

  public caseaNr: FormControl;
  public inneraNr: FormControl;
  public baraNr: FormControl;
  private caseamountNr: number;
  private inneramountNr: number;
  private isSubmitButtonEnabled = false;

  constructor(
    private router: Router,
    private locaStockService: LocaStockService,
    private typeOperationservice: TypeOperationService,
    private commonService: CommonService,
    private dialogsService: DialogsService
  ) {
    this.originalDt = new FormControl(new Date().toJSON().slice(0, 10), [Validators.required]);
    this.bookDt = new FormControl(new Date().toJSON().slice(0, 10), [Validators.required]);
    this.updstockNr = new FormControl(1);
    this.typeoperationCd = new FormControl('', [Validators.required]);
    this.stockinoutmemoTx = new FormControl('', [Validators.maxLength(validation.stockinoutmemoTx.maxLength)]);
    this.typeoperationCheck = new FormControl('');
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }

    this.caseaNr = new FormControl(validation.updstockNr.minNr, [Validators.required,Validators.pattern(validation.integer),Validators.min(validation.updstockNr.minNr),Validators.max(validation.updstockNr.maxNr)]);
    this.inneraNr = new FormControl(validation.updstockNr.minNr, [Validators.required,Validators.pattern(validation.integer),Validators.min(validation.updstockNr.minNr),Validators.max(validation.updstockNr.maxNr)]);
    this.baraNr = new FormControl(validation.updstockNr.minNr, [Validators.required,Validators.pattern(validation.integer),Validators.min(validation.updstockNr.minNr),Validators.max(validation.updstockNr.maxNr)]);
    this.updstockNr.disable();
  }

  ngAfterViewInit() {
    /*
    setTimeout(() => {
      this.onView();
    }, 500);
    */
  }

  onView() {
    this.errorInfo = '';
    this.working = true;
    this.typeOperationservice
      .get('stockupdFl=1')
      .then(outputJson => {
        this.working = false;
        this.typeoperations = outputJson.typeoperations;
        this.typeoperationCd.setValue('700');
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });

    // from previous page
    const locaStock: object = JSON.parse(sessionStorage.getItem('rowLocaStock'));
    if (locaStock === undefined) {
      return;
    }

    // var originalDt = locaStock['originalDt'];
    // var bookDt = locaStock['bookDt'];
    // var caseaNr = locaStock['caseaNr'];
    // var baraNr = locaStock['baraNr'];
    // var typeoperationCheck = locaStock['typeoperationCheck'];
    // var stockinoutmemoTx = locaStock['stockinoutmemoTx'];

    this.locastockpId = locaStock['locastockpId'];
    this.locaId = locaStock['locaId'];
    this.locaCd = locaStock['locaCd'];
    this.locaTx = locaStock['locaTx'];
    this.typestockTx = locaStock['typestockTx'];
    this.typecoldTx = locaStock['typecoldTx'];
    this.itemId = locaStock['itemId'];
    this.itemCd = locaStock['itemCd'];
    this.itemTx = locaStock['itemTx'];
    this.lotTx = locaStock['lotTx'];
    this.uselimitDt = locaStock['uselimitDt'];
    if (this.uselimitDt !== '' && this.uselimitDt !== '2099-01-01') {
      this.needUseLimit = true;
    } else {
      this.needUseLimit = false;
    }
    this.stockDt = locaStock['stockDt'];
    this.stockNr = locaStock['stockNr'];
    this.pstockNr = locaStock['pstockNr'];
    this.cstockNr = locaStock['cstockNr'];
    this.ownerTx = locaStock['ownerTx'];

    this.caseamountNr = locaStock['caseamountNr'];
    this.inneramountNr = locaStock['inneramountNr'];

    this.originalDt.setValue(new Date().toJSON().slice(0, 10));
    this.bookDt.setValue(new Date().toJSON().slice(0, 10));
    this.caseaNr.setValue(0);
    this.inneraNr.setValue(0);
    this.baraNr.setValue(0);
    this.typeoperationCheck.setValue('');
    this.stockinoutmemoTx.setValue('');
    this.onSumStock();
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  execute() {
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    let errors = false;
    if (this.originalDt.errors !== null) {
      this.originalDt.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.bookDt.errors !== null) {
      this.bookDt.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.updstockNr.errors !== null) {
      this.updstockNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.typeoperationCd.errors !== null) {
      this.typeoperationCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.stockinoutmemoTx.errors !== null) {
      this.stockinoutmemoTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (errors) {
      return;
    }

    let typeoperation = '700';
    if (this.updstockNr.value < 0) {
      typeoperation = this.typeoperationCheck.value === true ? '710' : '720';
    } else {
      typeoperation = this.typeoperationCheck.value === true ? '730' : '700';
    }

    if (this.locastockpId === 0) {
      this.locaStockService.post(
        this.originalDt.value,
        this.bookDt.value,
        this.locaId,
        this.itemId,
        this.lotTx,
        this.uselimitDt,
        this.stockDt,
        this.stockNr,
        typeoperation,
        this.stockinoutmemoTx.value.trim(),
        'we6012',
      )
        .then(outputJson => {
          sessionStorage.removeItem('rowLocaStock');
          this.closeButtonClick.emit(true);
          setTimeout(() => {
            this.working = false;
          },300);
        })
        .catch(error => {
          this.working = false;
          console.log(this.commonService.getErrorMessage(error));
          this.errorInfo = this.commonService.getErrorMessage(error);
        });
    } else {
      this.locaStockService.put(
        this.originalDt.value,
        this.bookDt.value,
        this.locastockpId,
        this.updstockNr.value,
        typeoperation,
        this.stockinoutmemoTx.value.trim(),
        'we6012',
      )
        .then(outputJson => {
          sessionStorage.removeItem('rowLocaStock');
          this.closeButtonClick.emit(true);
          setTimeout(() => {
            this.working = false;
          },300);
        })
        .catch(error => {
          this.working = false;
          console.log(this.commonService.getErrorMessage(error));
          this.errorInfo = this.commonService.getErrorMessage(error);
        });
    }
  }

  cancel() {
    this.errorInfo = '';

    sessionStorage.removeItem('rowLocaStock');
    this.closeButtonClick.emit(false);
  }

  nonStockDt() {
    if (this.checkbox == 1) {
      this.stockDt = '2000-01-01';
    } else {
      const locaStock: object = JSON.parse(sessionStorage.getItem('rowLocaStock'));
      this.stockDt = locaStock['stockDt'];
    }
  }

  ngOnChanges() {
    if (this.isShow) {
      this.isDelayHide = false;
      setTimeout(() => {
        this.onView();
      }, 500);
    } else {
      setTimeout(() => {
        this.scrollContent.nativeElement.scrollTop = 0;
        this.isDelayHide = true;
      }, 300);
    }
  }

  onSumStock() {
    this.errorInfo = '';

    // if (this.caseaNr.value < 0 || this.caseaNr.value == null) this.caseaNr.setValue(0);
    // if (this.baraNr.value < 0 || this.baraNr.value == null) this.baraNr.setValue(0);
    let caseNr = parseInt(this.caseaNr.value) * this.caseamountNr;
    let innerNr = parseInt(this.inneraNr.value) * this.inneramountNr;
    this.updstockNr.setValue(caseNr + innerNr + parseInt(this.baraNr.value));
  }
  ngDoCheck() {
    const locaStock: object = JSON.parse(sessionStorage.getItem('rowLocaStock'));
    if (!this.isShow) return;

    this.originalDtCls = this.originalDt.value === new Date().toJSON().slice(0, 10) ? '' : this.originalDt.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.bookDtCls = this.bookDt.value === new Date().toJSON().slice(0, 10) ? '' : this.bookDt.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.baraNrCls = this.baraNr.value === 0 ? '' : this.baraNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.caseaNrCls = this.caseaNr.value === 0 ? '' : this.caseaNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.inneraNrCls = this.inneraNr.value === 0 ? '' : this.inneraNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.typeoperationCheckCls = this.typeoperationCheck.value == 0 ? '' : this.STRINGS_ACTIVE;
    this.stockinoutmemoTxCls = this.stockinoutmemoTx.value === '' ? '' : this.stockinoutmemoTx.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.checkSubmitButtonState();
  }
  checkSubmitButtonState() {
    if (
      this.originalDtCls !== this.STRINGS_ERROR
      && this.bookDtCls !== this.STRINGS_ERROR
      && this.baraNrCls !== this.STRINGS_ERROR
      && this.caseaNrCls !== this.STRINGS_ERROR
      && this.inneraNrCls !== this.STRINGS_ERROR
      && this.stockinoutmemoTxCls !== this.STRINGS_ERROR
    ) {
      this.isSubmitButtonEnabled =
        this.originalDtCls === this.STRINGS_ACTIVE
        || this.bookDtCls === this.STRINGS_ACTIVE
        || this.baraNrCls === this.STRINGS_ACTIVE
        || this.caseaNrCls === this.STRINGS_ACTIVE
        || this.inneraNrCls === this.STRINGS_ACTIVE
        || this.typeoperationCheckCls === this.STRINGS_ACTIVE
        || this.stockinoutmemoTxCls === this.STRINGS_ACTIVE
    } else {
      this.isSubmitButtonEnabled = false;
    }
  }

  clrErr() {
    this.errorInfo = '';
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa6Stock/wa6012/wa6012.component.ts